// GraphQL endpoint routing configuration

export const GRAPHQL_ENDPOINTS = {
	INVENTORY: 'INVENTORY',
	COST_CAPTURE: 'CostCapture',
} as const

export type GraphQLEndpoint = typeof GRAPHQL_ENDPOINTS[keyof typeof GRAPHQL_ENDPOINTS]

export type GraphQLContextWithEndpoint = {
	endpoint?: GraphQLEndpoint,
}
